import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import {
  Box,
  Divider,
  Chip,
  Typography,
  Avatar,
  AvatarGroup,
  Tooltip,
  IconButton,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { Padding, WarningAmber as WarningAmberIcon } from '@mui/icons-material';
import AddBoxIcon from '@mui/icons-material/AddBox';
import DeleteIcon from '@mui/icons-material/Delete';
import Utils from 'commons/utils';
import ApiServices from 'services';
import { TextInput, Selection, ComboBox, ModalFormDetail } from 'components';
import moment from 'moment';

import { ServiceMainItem } from './service-main-item';
import { AddMainSer } from './add-main-ser';

const RenderService = ({ clientCareHistoryItem, clientInformationDetail, reloadData }) => {
  const [loading, setLoading] = useState(false);
  const [subServiceList, setSubServiceList] = useState([]);
  const [showAddMainSer, setShowAddMainSer] = useState(false);
  const [mainServiceList, setMainServiceList] = useState([]);

  const getServices = async () => {
    setLoading(true);
    try {
      const res = await ApiServices.getServices();
      if (res?.data) {
        const filterSubSer = res?.data?.filter((el) => el?.parentServiceId);
        setSubServiceList(filterSubSer || []);

        const filterMainSer = res?.data?.filter((el) => !el?.parentServiceId);
        setMainServiceList(filterMainSer || []);
      }
    } catch (err) {
      console.warn('initData - Client Groups', err);
    }
    setLoading(false);
  };

  useEffect(() => {
    getServices();
  }, []);

  let serParentList = clientCareHistoryItem?.arrService?.filter(
    (mainSer) => !mainSer?.parentServiceId,
  );

  const handleCloseAddMainSer = () => {
    setShowAddMainSer(false);
  };

  const handleAddMainService = () => {
    setShowAddMainSer(true);
  };

  const renderService = (item, index) => {
    const subServiceActive = clientCareHistoryItem?.arrService
      ?.filter((mainSer) => mainSer?.parentServiceId === item?.id)
      ?.map((el) => el?.id);

    const subServiceListFormat = subServiceList
      ?.filter((mainSer) => mainSer?.parentServiceId === item?.id)
      ?.map((el) => {
        if (subServiceActive?.includes(el?.id)) {
          el.isSelected = true;
        } else {
          el.isSelected = false;
        }
        return el;
      });

    return (
      <ServiceMainItem
        key={item?.id || index}
        dataItem={item}
        subServiceListFormat={subServiceListFormat || []}
        subServiceActive={subServiceActive || []}
        clientCompanyId={clientInformationDetail?.id}
        reloadData={reloadData}
        serParentList={serParentList}
      />
    );
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <b style={{ flex: 1 }}>Dịch vụ chăm sóc</b>
        <IconButton
          sx={{
            textAlign: 'center',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          color="primary"
          size="small"
          onClick={handleAddMainService}
        >
          <AddBoxIcon />
        </IconButton>
      </Box>
      <hr
        style={{
          margin: 0,
          padding: 0,
        }}
      />
      <Box>{serParentList?.map(renderService)}</Box>
      <ModalFormDetail
        maxWidth="sm"
        open={showAddMainSer}
        onCloseModal={handleCloseAddMainSer}
        title="Thêm dịch vụ"
      >
        <AddMainSer
          clientCompanyId={clientInformationDetail?.id}
          serParentListActive={serParentList?.map((el) => el?.id)}
          mainServiceList={mainServiceList}
          reloadData={reloadData}
          onCloseModal={handleCloseAddMainSer}
        />
      </ModalFormDetail>
    </Box>
  );
};

export { RenderService };
